import fetch from '../../api'
import getInstance from './queries/get-instance.gql'

const state = () => ({
  id: '',
  name: '',
  cms: {},
  config: {},
  features: {},
  theme: {},
  visitor: {
    location: {}
  }
})

const getters = {
  api (state) {
    return {
      space: state.cms.id,
      token: state.cms.token
    }
  },
  feature: state => (name, value = true) =>
    state.features[name] === undefined ? value : state.features[name]
}

const actions = {
  async load ({ commit }, host) {
    const { data: { instance } } = await fetch(getInstance, { host })
    if (!instance || !instance.id) return

    commit('opportunity/setContext', {
      instance: instance.id,
      platform: host
    }, { root: true })

    commit('setInstance', instance)
  }
}

const mutations = {
  setInstance (state, { config, cms, id, name, theme, features }) {
    state.config = config
    state.cms = cms
    state.id = id
    state.name = name
    state.theme = theme
    state.features = features || {}
  },
  setVisitorLocation (state, { city, zip, lat, lng } = {}) {
    state.visitor.location = { city, zip, lat, lng }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
